module.exports = __webpack_public_path__ + "static/force-plan-de804e724f4649692968b1536189794a.png";